import request from "@/utils/request";
const complaincebaseUrl = `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/compliance`;
const complainceRulebaseUrl = `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/compliance-rule`;
const complainceLimitbaseUrl = `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/compliance-limit`;
const complainceBlackbaseUrl = `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/blacklist`;
const masterBaseUrl = `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/master`;
const passwordFormatBaseUrl = `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/password-format`;
const payoutLimitBaseUrl = `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/txn-limit`;
const countrysetupBaseUrl = `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/country-setup`;
const FieldsetupsetupBaseUrl = `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/remitx`;
const BankbranchBaseUrl = `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/bank-branch`;
const PartnerBaseUrl = `${process.env.VUE_APP_PARTNER_GATEWAY_BASEURL}/api/v1/partner`;
const AllowCountryCurBaseUrl = `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/allow-country-currency`;
const partnerRouteBaseUrl = `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/partner-routing`;
const DashBoardRates = `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/dashboard-rate`;
const PayeeRouteUrl = `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/payee-route`;
const ServiceChargeUrl = `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/service-charge`;
const ledgerUrl = `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/ledger`;
const ExchangeRatesUrl = `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/fx-rate`;
const DepositeChannel = `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/deposit-channel`;
const MasterDataMap = `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/master`;
const payoutFieldsMap = `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/payout-field-setup`;
const sanctionsBulkBaseUrl = `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1`;
export default {
  //--------------------------allowedcurrency----------------------------------
  getcurrencydropdown(code) {
    return request({
      url: `${AllowCountryCurBaseUrl}/allow-country-currency-dropdown?country_code=${code}`,
      method: "GET",
    });
  },
  //--------------------------allowedcurrency----------------------------------
  updateRiskParameter(params, data) {
    return request({
      url: `${complaincebaseUrl}/update-compliance-parameter?id=${params}`,
      method: "PUT",
      data,
    });
  },
  // --------------------------------------COMPLAINCE ----------------------------------//
  //IND & Busrisk percentages
  getRiskscore(code) {
    return request({
      url: `${complaincebaseUrl}/get-risk-percentage?risk_type=${code}`,
      method: "GET",
    });
  },
  PostRiskParameterValue(data) {
    return request({
      url: `${complaincebaseUrl}/add-compliance-parameter-value`,
      method: "POST",
      data,
    });
  },
  getRiskParameterValue(id) {
    return request({
      url: `${complaincebaseUrl}/all-compliance-parameters-values-by-id?id=${id}`,
      method: "GET",
    });
  },
  PostBusParameter(data) {
    return request({
      url: `${complaincebaseUrl}/add-compliance-parameter`,
      method: "POST",
      data,
    });
  },
  updateStatus(id, is_active, data) {
    return request({
      url: `${complaincebaseUrl}/update-compliance-parameter-status?id=${id}&is_active=${is_active}`,
      method: "PUT",
      data,
    });
  },
  getValuescores(code) {
    return request({
      url: `${complaincebaseUrl}/all-compliance-parameters?user_type=${code}`,
      method: "GET",
    });
  },
  // --------------------------------------COMPLAINCE IND ----------------------------------//
  getValuescoresInd(code) {
    return request({
      url: `${complaincebaseUrl}/all-compliance-parameters?user_type=${code}`,
      method: "GET",
    });
  },
  PostINDParameter(data) {
    return request({
      url: `${complaincebaseUrl}/add-compliance-parameter`,
      method: "POST",
      data,
    });
  },
  updateStatusIND(id, is_active, data) {
    return request({
      url: `${complaincebaseUrl}/update-compliance-parameter-status?id=${id}&is_active=${is_active}`,
      method: "PUT",
      data,
    });
  },
  // --------------------------------------COMPLAINCE IND VALUE----------------------------------//
  updateStatusINDValue(id, is_active, data) {
    return request({
      url: `${complaincebaseUrl}/update-compliance-parameter-value-status?id=${id}&is_active=${is_active}`,
      method: "PUT",
      data,
    });
  },
  updateINDvalue(id, data) {
    return request({
      url: `${complaincebaseUrl}/update-compliance-parameter-value?id=${id}`,
      method: "PUT",
      data,
    });
  },
  // --------------------------------------COMPLAINCE BUS VALUE----------------------------------//
  getallbusValueScoresdata(code) {
    return request({
      url: `${complaincebaseUrl}/all-bus-compliance-parameters-values-by-id?id=${code}`,
      method: "GET",
    });
  },
  PostBUScompliancevalie(id, data) {
    return request({
      url: `${complaincebaseUrl}/add-bus-compliance-parameter-value?id=${id}`,
      method: "POST",
      data,
    });
  },
  updateStatusBUSValue(id, is_active, data) {
    return request({
      url: `${complaincebaseUrl}/update-bus-compliance-parameter-value-status?id${id}&is_active=${is_active}`,
      method: "PUT",
      data,
    });
  },
  updateBUSvalue(id, data) {
    return request({
      url: `${complaincebaseUrl}/update-bus-compliance-parameter-value?id=${id}`,
      method: "PUT",
      data,
    });
  },
  // --------------------------------------COMPLAINCE RULE----------------------------------//
  PostRule(data) {
    return request({
      url: `${complainceRulebaseUrl}/add-rule`,
      method: "POST",
      data,
    });
  },
  getrulebyId(code) {
    return request({
      url: `${complainceRulebaseUrl}/get-rule-by-id?rule_id=${code}`,
      method: "GET",
    });
  },
  updateRule(params, data) {
    return request({
      url: `${complainceRulebaseUrl}/update-rule?rule_id=${params}`,
      method: "PUT",
      data,
    });
  },
  getrules() {
    return request({
      url: `${complainceRulebaseUrl}/get-all-rules`,
      method: "GET",
    });
  },
  // --------------------------------------COMPLAINCE LIMIT----------------------------------//
  hideButton() {
    return request({
      url: `${complainceLimitbaseUrl}/get-limit-count-status`,
      method: "GET",
    });
  },
  PostLimit(data) {
    return request({
      url: `${complainceLimitbaseUrl}/add-limit`,
      method: "POST",
      data,
    });
  },
  getallLimits() {
    return request({
      url: `${complainceLimitbaseUrl}/all-limits`,
      method: "GET",
    });
  },
  getLimitbyId(code) {
    return request({
      url: `${complainceLimitbaseUrl}/get-limit-by-id?limit_id=${code}`,
      method: "GET",
    });
  },
  updateLimit(params, data) {
    return request({
      url: `${complainceLimitbaseUrl}/update-limit?limit_id=${params}`,
      method: "PUT",
      data,
    });
  },
  updateLimitstatus(limit_id, limit_status, data) {
    return request({
      url: `${complainceLimitbaseUrl}/update-status?limit_id=${limit_id}&limit_status=${limit_status}`,
      method: "PUT",
      data,
    });
  },
  // --------------------------------------COMPLAINCE LIMIT AUTH----------------------------------//
  PostAuth(data) {
    return request({
      url: `${complainceLimitbaseUrl}/add-authorization`,
      method: "POST",
      data,
    });
  },
  getallAuths() {
    return request({
      url: `${complainceLimitbaseUrl}/all-authorization`,
      method: "GET",
    });
  },
  getAuthbyId(code) {
    return request({
      url: `${complainceLimitbaseUrl}/get-by-id?id=${code}`,
      method: "GET",
    });
  },
  updateAuthstatus(id, is_active, data) {
    return request({
      url: `${complainceLimitbaseUrl}/update-authorization-status?id=${id}&transaction_status=${is_active}`,
      method: "PUT",
      data,
    });
  },
  updateAuth(params, data) {
    return request({
      url: `${complainceLimitbaseUrl}/update-authorization ?id=${params}`,
      method: "PUT",
      data,
    });
  },
  // --------------------------------------MANAGE COMPLAINCE----------------------------------//
  PostMAnual(data) {
    return request({
      url: `${complainceBlackbaseUrl}/add`,
      method: "POST",
      data,
    });
  },
  // --------------------------------------SANCTION----------------------------------//
  getSanctionhistory(code) {
    return request({
      url: `${complainceBlackbaseUrl}/get-bulkuploaddocument-data?partner_id=${code}`,
      method: "GET",
    });
  },
  getSuccess(code) {
    return request({
      url: `${complainceBlackbaseUrl}/get-blacklisthistory-data?upload_document_id=${code}`,
      method: "GET",
    });
  },
  // uploadFiles(data) {
  //   return request({
  //     url: `${complainceBlackbaseUrl}/upload-black-list`,
  //     method: "POST",
  //     data,
  //   });
  // },
  uploadFiles(data) {
    return request({
      url: `${complainceBlackbaseUrl}/upload-moha-list`,
      method: "POST",
      data,
    });
  },
  validateSanctionsBulk(data) {
    return request({
      url: `${sanctionsBulkBaseUrl}/sanctions-bulk-validate`,
      method: "POST",
      data,
    });
  },
  commitSanctionsBulk(uploadToken, data) {
    return request({
      url: `${sanctionsBulkBaseUrl}/sanctions-bulk-upload`,
      method: "POST",
      params: { upload_token: uploadToken },
      data,
    });
  },
  getSanctionsUploadSummary(params) {
    return request({
      url: `${sanctionsBulkBaseUrl}/get-upload-summery`,
      method: "GET",
      params,
    });
  },
  getSanctionsUploadRecords(params) {
    return request({
      url: `${sanctionsBulkBaseUrl}/get-upload-records`,
      method: "GET",
      params,
    });
  },
  getSearchresult(code) {
    return request({
      url: `${complainceBlackbaseUrl}/get-blacklist-data?data_source=${code}`,
      method: "GET",
    });
  },
  getCount() {
    return request({
      url: `${complainceBlackbaseUrl}/get-blacklist-data-count`,
      method: "GET",
    });
  },
  Searchlist(code, data) {
    return request({
      url: `${complainceBlackbaseUrl}/get-name-match?name=${code}`,
      method: "POST",
      data,
    });
  },
  getSanctionDetail(source, rowId) {
    return request({
      url: `${complainceBlackbaseUrl}/get-sanction-detail`,
      method: "GET",
      params: { source, row_id: rowId },
    });
  },
  //-----------------------------------MASTER BASE URL-----------------------------//
  getParameters() {
    return request({
      url: `${masterBaseUrl}/all-master-parameter`,
      method: "GET",
    });
  },
  getExistingParameters() {
    return request({
      url: `${masterBaseUrl}/get-existing-parameters`,
      method: "GET",
    });
  },
  importMasterDataFiles(id, data) {
    return request({
      url: `${masterBaseUrl}/upload-master-data?parameter_id=${id}`,
      method: "POST",
      data,
    });
  },
  getParametersValues(id, params) {
    return request({
      url: `${masterBaseUrl}/get-master-parameter?parameter_id=${id}`,
      method: "GET",
      params: params,
    });
  },
  getParametersValuesUsertype(params) {
    return request({
      url: `${masterBaseUrl}/get-master-parameter`,
      method: "GET",
      params: params,
    });
  },
  getValidateParValCode(Id, value_code, user_type) {
    return request({
      url: `${masterBaseUrl}/validate/parameter-value-code?parameter_id=${Id}&value_code=${value_code}&user_type=${user_type}`,
      method: "GET",
    });
  },
  getValidateParValName(Id, value, user_type) {
    return request({
      url: `${masterBaseUrl}/validate/parameter-value-name?parameter_id=${Id}&value=${value}&user_type=${user_type}`,
      method: "GET",
    });
  },
  getValidateParameterCode(parameter_code) {
    return request({
      url: `${masterBaseUrl}/validate/parameter-code?parameter_code=${parameter_code}`,
      method: "GET",
    });
  },
  getValidateParameterName(parameter_name) {
    return request({
      url: `${masterBaseUrl}/validate/parameter-name?parameter_name=${parameter_name}`,
      method: "GET",
    });
  },
  addParameterDetails(data) {
    return request({
      url: `${masterBaseUrl}/add-master-parameter`,
      method: "POST",
      data,
    });
  },
  addParameterValueDetails(id, data) {
    return request({
      url: `${masterBaseUrl}/add-master-parameter-value?parameter_id=${id}`,
      method: "POST",
      data,
    });
  },
  addExistingParameterDetails(parameter_id, val_id, data) {
    return request({
      url: `${masterBaseUrl}/add-parameter-value-list?parameter_id=${parameter_id}&parameter_val_id=${val_id}`,
      method: "POST",
      data,
    });
  },
  updateParameterValueDetails(Id, data) {
    return request({
      url: `${masterBaseUrl}/update-master-parameter-value?id=${Id}`,
      method: "PUT",
      data,
    });
  },
  activateUpdateParValDetails(Id, isactive) {
    return request({
      url: `${masterBaseUrl}/update-parameter-value-status?id=${Id}&is_active=${isactive}`,
      method: "PUT",
    });
  },
  activeUpdateParameterDetails(Id, isactive) {
    return request({
      url: `${masterBaseUrl}/update-parameter-status?parameter_id=${Id}&is_active=${isactive}`,
      method: "PUT",
    });
  },
  updateParameterDetails(update_Id, data) {
    return request({
      url: `${masterBaseUrl}/update-master-parameter?parameter_id=${update_Id}`,
      method: "PUT",
      data,
    });
  },
  deleteParameterDetails(delete_Id) {
    return request({
      url: `${masterBaseUrl}/delete-parameter?parameter_id=${delete_Id}`,
      method: "DELETE",
    });
  },
  deleteParameterValDetails(delete_Id) {
    return request({
      url: `${masterBaseUrl}/delete-parameter-value?id=${delete_Id}`,
      method: "DELETE",
    });
  },
  //-----------------------------------MASTER DATA MAP BASE URL-----------------------------//

  getallMainparameters(params) {
    return request({
      url: `${masterBaseUrl}/get-mappingdata-by-maplevel`,
      method: "GET",
      params: params,
    });
  },
  //------------------------------PASSWORD FORMAT-----------------------------//
  savePassword(data) {
    return request({
      url: `${passwordFormatBaseUrl}/register-password-format`,
      method: "POST",
      data,
    });
  },
  getFormatId(data) {
    return request({
      url: `${passwordFormatBaseUrl}/get-password-format?format_id=1`,
      method: "GET",
      data,
    });
  },
  //-----------------------------------PAYOUT LIMIT-----------------------------//
  getPayoutLimit() {
    return request({
      url: `${payoutLimitBaseUrl}/all-country-payout-limit`,
      method: "GET",
    });
  },
  savePayoutLimit(type, data) {
    return request({
      url: `${payoutLimitBaseUrl}/add-country-payout-limit?receiver_type=${type}`,
      method: "POST",
      data,
    });
  },
  updatePayoutLimit(Id, data) {
    return request({
      url: `${payoutLimitBaseUrl}/update-country-pay-limit?id=${Id}`,
      method: "PUT",
      data,
    });
  },
  deletePayoutLimit(Id) {
    return request({
      url: `${payoutLimitBaseUrl}/delete-country-payout-limit?id=${Id}`,
      method: "DELETE",
    });
  },
  //----------------------------TAX CONFIGARATION-------------------------------------//
  gettaxCollectionLimit() {
    return request({
      url: `${payoutLimitBaseUrl}/all-coll-limit`,
      method: "GET",
    });
  },

  //------------------------------------COUNTRY SETUP----------------------------------//
  getCountrysetupList() {
    return request({
      url: `${countrysetupBaseUrl}/get-all-countries`,
      method: "GET",
    });
  },
  getPartnerTypelist(country_id) {
    return request({
      url: `${countrysetupBaseUrl}/get-country-full-info-by-id?country_id=${country_id}`,
      method: "GET",
    });
  },
  updateCountrystatus(Id, is_active, data) {
    return request({
      url: `${countrysetupBaseUrl}/update-country-status?id=${Id}&is_active=${is_active}`,
      method: "PUT",
      data,
    });
  },
  //------------------------------------ADDITIONAL COUNTRY SETUP----------------------------------//
  getallpartners(code) {
    return request({
      url: `${countrysetupBaseUrl}/get-country-partner-type?country_id=${code}`,
      method: "GET",
    });
  },
  getallKeyschecks(code) {
    return request({
      url: `${countrysetupBaseUrl}/get-country-additional-data?country_id=${code}`,
      method: "GET",
    });
  },
  getallpaymets(code) {
    return request({
      url: `${countrysetupBaseUrl}/get-country-pp-type?country_id=${code}`,
      method: "GET",
    });
  },
  savePartners(id, data) {
    return request({
      url: `${countrysetupBaseUrl}/add-country-pp-type?country_id=${id}`,
      method: "POST",
      data,
    });
  },
  saveKeyschecks(id, data) {
    return request({
      url: `${countrysetupBaseUrl}/add-country-data?country_id=${id}`,
      method: "POST",
      data,
    });
  },
  savePayment(id, data) {
    return request({
      url: `${countrysetupBaseUrl}/add-country-pp-type?country_id=${id}`,
      method: "POST",
      data,
    });
  },
  //------------------------------------FIELD SETUP----------------------------------//
  getServicetype(code) {
    return request({
      url: `${FieldsetupsetupBaseUrl}/admin-payment-modes-by-country?country=${code}&user_type=IND`,
      method: "GET",
    });
  },
  //------------------------------------SETTINGS MASTERS BANK----------------------------------//
  getBankList() {
    return request({
      url: `${BankbranchBaseUrl}/get-filter-master-bank`,
      method: "GET",
    });
  },
  activeUpdate(id, is_active) {
    return request({
      url: `${BankbranchBaseUrl}/update-master-bank-status?bank_id=${id}&is_active=${is_active}`,
      method: "PUT",
    });
  },
  addMasterBank(data) {
    return request({
      url: `${BankbranchBaseUrl}/add-to-master-bank`,
      method: "POST",
      data,
    });
  },
  updateMasterBank(id, data) {
    return request({
      url: `${BankbranchBaseUrl}/update-master-bank?bank_id=${id}`,
      method: "PUT",
      data,
    });
  },

  //-----------------------------------ALLOW COUNTRY CURRENCY------------------------------------------//

  getCountryCurrencyData(country_code) {
    return request({
      url: `${AllowCountryCurBaseUrl}/all-allow-country-currency?country_code=${country_code}`,
      method: "GET",
    });
  },
  addCountryCurrencyData(data) {
    return request({
      url: `${AllowCountryCurBaseUrl}/add-allow-country-currency`,
      method: "POST",
      data,
    });
  },
  updateCountryCurrencyData(id, data) {
    return request({
      url: `${AllowCountryCurBaseUrl}/update-allow-country-currency?id=${id}`,
      method: "PUT",
      data,
    });
  },
  activeCurrencyUpdate(id, is_active) {
    return request({
      url: `${AllowCountryCurBaseUrl}/update-allow-country-currency-status?id=${id}&is_default=${is_active}`,
      method: "PUT",
    });
  },
  deleteCurrencyData(id) {
    return request({
      url: `${AllowCountryCurBaseUrl}/delete-allow-country-currency-status?id=${id}`,
      method: "DELETE",
    });
  },
  //-----------------------------------STATE INFO CURRENCY------------------------------------------//
  getStatesById(id) {
    return request({
      url: `${countrysetupBaseUrl}/get-states-by-id?id=${id}`,
      method: "GET",
    });
  },
  getStatesByCountry(country_code) {
    return request({
      url: `${countrysetupBaseUrl}/get-states-by-country-code?country_code=${country_code}`,
      method: "GET",
    });
  },
  addStateInfoData(data) {
    return request({
      url: `${countrysetupBaseUrl}/add-state`,
      method: "POST",
      data,
    });
  },
  deleteStateInfoData(id) {
    return request({
      url: `${countrysetupBaseUrl}/delete-state?id=${id}`,
      method: "DELETE",
    });
  },
  updateStateInfoData(id, data) {
    return request({
      url: `${countrysetupBaseUrl}/update-state?id=${id}`,
      method: "PUT",
      data,
    });
  },
  //-----------------------------------STATE INFO CURRENCY------------------------------------------//
  getCitiesById(id) {
    return request({
      url: `${countrysetupBaseUrl}/get-states-by-id?id=${id}`,
      method: "GET",
    });
  },
  getCitiesList(country_code, state_code) {
    return request({
      url: `${countrysetupBaseUrl}/get-cities-by-state?country_code=${country_code}&state_code=${state_code}`,
      method: "GET",
    });
  },
  addCityInfoData(data) {
    return request({
      url: `${countrysetupBaseUrl}/add-city`,
      method: "POST",
      data,
    });
  },
  deleteCityInfoData(id) {
    return request({
      url: `${countrysetupBaseUrl}/delete-city?id=${id}`,
      method: "DELETE",
    });
  },
  updateCityInfoData(id, data) {
    return request({
      url: `${countrysetupBaseUrl}/update-city?id=${id}`,
      method: "PUT",
      data,
    });
  },

  //--------------------------------PARTNER ROUTE-----------------------------------------//

  getAllPartnerRouteData(country, payment_mode, partner) {
    return request({
      url: `${partnerRouteBaseUrl}/all-partner-routing?country=${country}&paymentmode=${payment_mode}&partner=${partner}`,
      method: "GET",
    });
  },
  getAllPartnerRouteById(id) {
    return request({
      url: `${partnerRouteBaseUrl}/all-partner-routing-by-id?id=${id}`,
      method: "GET",
    });
  },
  AddPartnerRouteData(data) {
    return request({
      url: `${partnerRouteBaseUrl}/add-partner-routing`,
      method: "POST",
      data,
    });
  },
  getPartnerByCountry(country_code) {
    return request({
      url: `${partnerRouteBaseUrl}/get-partner-by-country?company_country_code=${country_code}`,
      method: "GET",
    });
  },
  getPaymentByCountry(country_code) {
    return request({
      url: `${partnerRouteBaseUrl}/get-paymode-by-country?country_code=${country_code}`,
      method: "GET",
    });
  },
  updatePartnerRouteData(id, data) {
    return request({
      url: `${partnerRouteBaseUrl}/update-partner-routing?id=${id}`,
      method: "PUT",
      data,
    });
  },
  updatePartnerRouteStatus(id, is_active) {
    return request({
      url: `${partnerRouteBaseUrl}/update-partner-routing-status?id=${id}&is_active=${is_active}`,
      method: "PUT",
    });
  },
  deletePartnerrouting(deleteId) {
    return request({
      url: `${partnerRouteBaseUrl}/delete-partner-routing?id=${deleteId}`,
      method: "DELETE",
    });
  },
  //----------------------------------Dashboard Rates ------------------------------//
  getAllratesData(rate_type, country) {
    return request({
      url: `${DashBoardRates}/get-rates?rate_type=${rate_type}&country=${country}`,
      method: "GET",
    });
  },
  // getAllratesData() {
  //   return request({
  //     url: `${DashBoardRates}/get-rates`,
  //     method: "GET",
  //   });
  // },
  getupdateCalculation() {
    return request({
      url: `${DashBoardRates}/update-calculation`,
      method: "PUT",
    });
  },
  updateAllPercentages(percentage) {
    return request({
      url: `${DashBoardRates}/update-all-percentage?percentage=${percentage}`,
      method: "PUT",
    });
  },
  updatePercentages(percentage, data) {
    return request({
      url: `${DashBoardRates}/update-percentage?percentage=${percentage}`,
      method: "PUT",
      data,
    });
  },
  updateccrate(params) {
    return request({
      url: `${DashBoardRates}/update-cc-rate?rate_id=${params.id}&cc_rate=${params.rate}`,
      method: "PUT",
    });
  },

  updateDashboardStatus(Id, isactive) {
    return request({
      url: `${DashBoardRates}/update-status?rate_id=${Id}&is_active=${isactive}`,
      method: "PUT",
    });
  },
  //-------------------------------Master Bank And Branch----------------------------------------//

  getPartnerBanks(country_code, partner_id, payment_mode) {
    return request({
      url: `${PartnerBaseUrl}/get-partner-bank-list?country_code=${country_code}&partner_id=${partner_id}&payment_mode=${payment_mode}`,
      method: "GET",
    });
  },
  getAllMasterBanks(country_code, payment_mode) {
    return request({
      url: `${BankbranchBaseUrl}/bank-list?country_code=${country_code}&payment_mode=${payment_mode}`,
      method: "GET",
    });
  },
  AddBankMasterData(data) {
    return request({
      url: `${BankbranchBaseUrl}/create-bank`,
      method: "POST",
      data,
    });
  },
  updateBankMasterData(id, data) {
    return request({
      url: `${BankbranchBaseUrl}/update-bank?bank_id=${id}`,
      method: "PUT",
      data,
    });
  },
  getAllBanksdropdown(country_code, payment_mode) {
    return request({
      url: `${BankbranchBaseUrl}/bank-list?country_code=${country_code}&payment_mode=${payment_mode}`,
      method: "GET",
    });
  },
  getBankById(id) {
    return request({
      url: `${BankbranchBaseUrl}/get-bank?bank_id=${id}`,
      method: "GET",
    });
  },
  AddBankData(data) {
    return request({
      url: `${PartnerBaseUrl}/add-partner-banks`,
      method: "POST",
      data,
    });
  },
  updateBankData(data) {
    return request({
      url: `${PartnerBaseUrl}/update-partner-bank-mapping`,
      method: "PUT",
      data,
    });
  },
  updateBankStatus(id, is_active) {
    return request({
      url: `${BankbranchBaseUrl}/update-master-bank-status?bank_id=${id}&is_active=${is_active}`,
      method: "PUT",
    });
  },
  getAllBranches(bank_id) {
    return request({
      url: `${BankbranchBaseUrl}/branch-list?bank_id=${bank_id}`,
      method: "GET",
    });
  },
  getBranchById(id) {
    return request({
      url: `${BankbranchBaseUrl}/get-branch?branch_id=${id}`,
      method: "GET",
    });
  },
  AddBranchData(data) {
    return request({
      url: `${BankbranchBaseUrl}/create-branch`,
      method: "POST",
      data,
    });
  },
  updateBranchData(id, data) {
    return request({
      url: `${BankbranchBaseUrl}/update-branch?branch_id=${id}`,
      method: "PUT",
      data,
    });
  },
  updateBranchStatus(id, is_active) {
    return request({
      url: `${BankbranchBaseUrl}/update-master-branch-status?branch_id=${id}&is_active=${is_active}`,
      method: "PUT",
    });
  },
  //-------------------------------Payee Route Api's----------------------------------------//

  getAllPayeeRoutes(country_code, payment_mode) {
    return request({
      url: `${PayeeRouteUrl}/bank-list?country_code=${country_code}&payment_mode=${payment_mode}`,
      method: "GET",
    });
  },
  getAllPayRoutes(params) {
    return request({
      url: `${PayeeRouteUrl}/get-active-payees`,
      method: "GET",
      params: params,
    });
  },

  deletePayeeRouteById(data) {
    return request({
      url: `${PayeeRouteUrl}/update-payee-routing-status`,
      method: "PUT",
      params: data,
      data,
    });
  },
  getPayRouteById(Id) {
    return request({
      url: `${PayeeRouteUrl}/get-active-routes?route_id=${Id}`,
      method: "GET",
    });
  },
  addPayRoutes(data) {
    return request({
      url: `${PayeeRouteUrl}/add-payee-route`,
      method: "POST",
      data,
    });
  },
  getpaymentmodeBycntry(country_code) {
    return request({
      url: `${PayeeRouteUrl}/get-payment-modes?country_code=${country_code}`,
      method: "GET",
    });
  },
  getpartnerBycntry(country_code, payment_mode) {
    return request({
      url: `${PayeeRouteUrl}/get-active-partners?country_code=${country_code}&payment_mode=${payment_mode}`,
      method: "GET",
    });
  },
  getServiceChargeData(params) {
    return request({
      url: `${ServiceChargeUrl}/get-service-charge`,
      method: "GET",
      params: params,
    });
  },
  getChargeById(id) {
    return request({
      url: `${ServiceChargeUrl}/get-service-charge-by-id?id=${id}`,
      method: "GET",
    });
  },
  updateChargeById(id, data) {
    return request({
      url: `${ServiceChargeUrl}/update-service-charge?id=${id}`,
      method: "PUT",
      data,
    });
  },
  addCountryWise(data) {
    return request({
      url: `${ServiceChargeUrl}/add-service-charge-country`,
      method: "POST",
      data,
    });
  },
  addPartnerWise(data) {
    return request({
      url: `${ServiceChargeUrl}/add-service-charge-partner`,
      method: "POST",
      data,
    });
  },
  addCountryBranchWise(data) {
    return request({
      url: `${ServiceChargeUrl}/add-service-charge-country-branch`,
      method: "POST",
      data,
    });
  },
  addPartnerBranchWise(data) {
    return request({
      url: `${ServiceChargeUrl}/add-service-charge-partner-branch`,
      method: "POST",
      data,
    });
  },
  deleteServiceCharge(id) {
    return request({
      url: `${ServiceChargeUrl}/delete-service-charge?id=${id}`,
      method: "DELETE",
    });
  },
  //-------------------------------Ledger Account Details Api's----------------------------------------//
  getallLedgers() {
    return request({
      url: `${ledgerUrl}/all-ledgers`,
      method: "GET",
    });
  },
  getallLedgersDropdown() {
    return request({
      url: `${ledgerUrl}/all-ledger-dropdown`,
      method: "GET",
    });
  },
  getallLedgersBalance(params) {
    return request({
      url: `${ledgerUrl}/ledger-balance`,
      method: "GET",
      params: params,
    });
  },
  getpartnerBalance(params) {
    return request({
      url: `${ledgerUrl}/get-partner-balance`,
      method: "GET",
      params: params,
    });
  },
  getallLedgersByCountry(id) {
    return request({
      url: `${ledgerUrl}/get-ledger-by-country?country=${id}`,
      method: "GET",
    });
  },
  getallLedgerById(ledger_id) {
    return request({
      url: `${ledgerUrl}/get-ledger-by-id?ledger_id=${ledger_id}`,
      method: "GET",
    });
  },
  addNewLedger(data) {
    return request({
      url: `${ledgerUrl}/add-ledger`,
      method: "POST",
      data,
    });
  },
  updateledgerById(id, data) {
    return request({
      url: `${ledgerUrl}/update-ledger?ledger_id=${id}`,
      method: "PUT",
      data,
    });
  },
  deleteLedgerById(deleteId) {
    return request({
      url: `${ledgerUrl}/delete-ledger?ledger_id=${deleteId}`,
      method: "DELETE",
    });
  },
  getallLedgerDetailsById(ledger_id) {
    return request({
      url: `${ledgerUrl}/all-ledger-details?ledger_id=${ledger_id}`,
      method: "GET",
    });
  },
  getLedgerDetailsById(id) {
    return request({
      url: `${ledgerUrl}/get-ledger-details?id=${id}`,
      method: "GET",
    });
  },
  addLedgerDetails(data) {
    return request({
      url: `${ledgerUrl}/add-ledger-details`,
      method: "POST",
      data,
    });
  },
  updateledgerDetailsById(id, data) {
    return request({
      url: `${ledgerUrl}/update-ledger-details?id=${id}`,
      method: "PUT",
      data,
    });
  },
  deleteLedgerDetailsById(deleteId) {
    return request({
      url: `${ledgerUrl}/delete-ledger-details?id=${deleteId}`,
      method: "DELETE",
    });
  },

  //--------------------------------------FX Rates set up API's-------------------------------//

  getAllFixRates(rate_level) {
    return request({
      url: `${ExchangeRatesUrl}/get-all-rate-setups?rate_level=${rate_level}`,
      method: "GET",
    });
  },
  getRatesByCountry(rate_level, country) {
    return request({
      url: `${ExchangeRatesUrl}/get-all-rate-setups-by-country?rate_level=${rate_level}&country=${country}`,
      method: "GET",
    });
  },
  getRatesById(id) {
    return request({
      url: `${ExchangeRatesUrl}/get-rate-setup-by-id?id=${id}`,
      method: "GET",
    });
  },
  addFixedRate(data) {
    return request({
      url: `${ExchangeRatesUrl}/add-rate-setup`,
      method: "POST",
      data,
    });
  },
  addBranchFixedRate(data) {
    return request({
      url: `${ExchangeRatesUrl}/add-branch-rate-setup`,
      method: "POST",
      data,
    });
  },
  updateFixedRate(id, data) {
    return request({
      url: `${ExchangeRatesUrl}/update-rate-setup?id=${id}`,
      method: "PUT",
      data,
    });
  },
  deleteFixedRate(id) {
    return request({
      url: `${ExchangeRatesUrl}/delete-rate-setup?id=${id}`,
      method: "DELETE",
    });
  },
  //--------------------------------------FX Cost Rates set up API's-------------------------------//

  getAllFixCostRates(params) {
    return request({
      url: `${ExchangeRatesUrl}/all-cost-rates`,
      method: "GET",
      params: params,
    });
  },
  getCostRatesById(id) {
    return request({
      url: `${ExchangeRatesUrl}/get-cost-rate-by-id?id=${id}`,
      method: "GET",
    });
  },
  getlatestschedulerate(params) {
    return request({
      url: `${ExchangeRatesUrl}/get-partner-rates`,
      method: "GET",
      params: params,
    });
  },
  addFxCostRate(data) {
    return request({
      url: `${ExchangeRatesUrl}/add-cost-rate`,
      method: "POST",
      data,
    });
  },
  updateFxCostRate(id, data) {
    return request({
      url: `${ExchangeRatesUrl}/update-cost-rate?id=${id}`,
      method: "PUT",
      data,
    });
  },

  deleteFxCostRate(id) {
    return request({
      url: `${ExchangeRatesUrl}/delete-cost-rate?id=${id}`,
      method: "DELETE",
    });
  },
  //----------------------------- FX Exchnage Cost Rates set up API's--------------------------------//
  getAllExchangeRates(params) {
    return request({
      url: `${ExchangeRatesUrl}/get-all-exchange-rates`,
      method: "GET",
      params: params,
    });
  },
  getExchangeRatesHistory(params) {
    return request({
      url: `${ExchangeRatesUrl}/get-ex-rates-history`,
      method: "GET",
      params: params,
    });
  },
  // getCostRatesById(id) {
  //   return request({
  //     url: `${ExchangeRatesUrl}/get-cost-rate-by-id?id=${id}`,
  //     method: "GET",
  //   });
  // },

  addExchageRate(data) {
    return request({
      url: `${ExchangeRatesUrl}/add-ex-rate`,
      method: "POST",
      data,
    });
  },
  updateExchangeRate(data) {
    return request({
      url: `${ExchangeRatesUrl}/update-ex-rate`,
      method: "PUT",
      data,
    });
  },
  calculateExRtae(id, data) {
    return request({
      url: `${ExchangeRatesUrl}/calculate-ex-rate?rate_id=${id}`,
      method: "PUT",
      data,
    });
  },
  calculateTxnrate(id, data) {
    return request({
      url: `${ExchangeRatesUrl}/calculate-ex-rate-txn?rate_id=${id}`,
      method: "PUT",
      data,
    });
  },
  deleteExchangeRate(id) {
    return request({
      url: `${ExchangeRatesUrl}/delete-ex-rate?id=${id}`,
      method: "DELETE",
    });
  },
  //----------------------------------FX COST RATE SCHEDULE-----------------------------------------//

  getallcostratespartner(params) {
    return request({
      url: `${ExchangeRatesUrl}/all-cost-rates-partner`,
      method: "GET",
      params: params,
    });
  },
  getallfetchcostratespartner(params) {
    return request({
      url: `${ExchangeRatesUrl}/fetch-all-cost-rates-partner`,
      method: "GET",
      params: params,
    });
  },
  //---

  //-------------------------- Deposite Channel API'S-------------------------------//
  getChannelByCountry(country) {
    return request({
      url: `${DepositeChannel}/get-all-channels-by-country?country=${country}`,
      method: "GET",
    });
  },
  getALlDepositeChannel() {
    return request({
      url: `${DepositeChannel}/get-all-channels`,
      method: "GET",
    });
  },
  getDepositeChannelById(id) {
    return request({
      url: `${DepositeChannel}/get-channel-by-id?channel_id=${id}`,
      method: "GET",
    });
  },
  addDepositeChannel(data) {
    return request({
      url: `${DepositeChannel}/add-channel`,
      method: "POST",
      data,
    });
  },
  updateDepositeChannel(id, data) {
    return request({
      url: `${DepositeChannel}/update-channel?channel_id=${id}`,
      method: "PUT",
      data,
    });
  },
  deleteDepositeChannel(id) {
    return request({
      url: `${DepositeChannel}/delete-channel?channel_id=${id}`,
      method: "DELETE",
    });
  },
  uploadBanklogo(id, data) {
    return request({
      url: `${DepositeChannel}/upload-logo?channel_id=${id}`,
      method: "POST",
      data,
    });
  },

  //-----------------------MASTER CW DATA MAPPING --------------------------------//
  getMasterDataList(country) {
    return request({
      url: `${MasterDataMap}/get-param-mappingdata?country=${country}`,
      method: "GET",
    });
  },
  getMasterParameterList(id) {
    return request({
      url: `${MasterDataMap}/get-paramvalue-mappingdata?parameter=${id}`,
      method: "GET",
    });
  },
  addMasterData(data) {
    return request({
      url: `${MasterDataMap}/add-mapping-data`,
      method: "POST",
      data,
    });
  },

  updateMasterStatus(id, active) {
    return request({
      url: `${MasterDataMap}/update-param-mapping-pw?parameter=${id}&is_active=${active}`,
      method: "PUT",
    });
  },
  updateCWValueStatus(id, active) {
    return request({
      url: `${MasterDataMap}/update-param-mapping-cw?parameter=${id}&is_active=${active}`,
      method: "PUT",
    });
  },

  //-----------------------MASTER PW DATA MAPPING --------------------------------//

  getMasterPWDataList(params) {
    return request({
      url: `${MasterDataMap}/get-partner-param-mappingdata`,
      method: "GET",
      params,
    });
  },
  getMasterPwParameterList(params) {
    return request({
      url: `${MasterDataMap}/get-partner-paramvalue-mappingdata`,
      method: "GET",
      params: params,
    });
  },
  updatePwParameterList(data) {
    return request({
      url: `${MasterDataMap}/update-partner-param-mapping`,
      method: "PUT",
      data,
    });
  },
  updatemappingStatus(params) {
    return request({
      url: `${MasterDataMap}/update-mapping-status`,
      method: "PUT",
      params: params,
    });
  },
  //--------------------------------------Payout Field Setup Api's-------------------------------//

  getAllPayoutSetup(params) {
    return request({
      url: `${payoutFieldsMap}/all`,
      method: "GET",
      params: params,
    });
  },
  getPayoutsetupByid(id) {
    return request({
      url: `${payoutFieldsMap}/get?id=${id}`,
      method: "GET",
    });
  },
  addpayoutFieldStup(data) {
    return request({
      url: `${payoutFieldsMap}/add`,
      method: "POST",
      data,
    });
  },
  updatepayoutFieldStup(data) {
    return request({
      url: `${payoutFieldsMap}/update`,
      method: "PUT",
      data: data,
    });
  },
  updatepayoutFieldStupStatus(data) {
    return request({
      url: `${payoutFieldsMap}/update-status`,
      method: "PUT",
      params: data,
      data: data,
    });
  },
  //Beneficiary Limit
  updateBeneficiaryLimit(data) {
    return request({
      url: `${MasterDataMap}/update-master-parameter-value?id=${data.value}`,
      method: "PUT",
      data: data,
    });
  },
  uploadFileBankBranches(bank_id, data) {
    return request({
      url: `${BankbranchBaseUrl}/upload-master-branch?bank_id=${bank_id}`,
      method: "POST",
      data,
    });
  },
};
